import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  FaCalendarAlt,
  FaUsers,
  FaChartLine,
  FaGlobe,
  FaTrophy,
  FaRocket,
} from "react-icons/fa";

const StatCard = ({ icon, number, label, description, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
    >
      <Card className="h-100 stat-card text-center">
        <Card.Body>
          <div className="stat-icon mb-3">{icon}</div>
          <h3 className="fw-bold text-primary">{number}</h3>
          <h6 className="mb-2">{label}</h6>
          <p className="text-muted small">{description}</p>
        </Card.Body>
      </Card>
    </motion.div>
  );
};

const AboutUs = () => {
  const companyStats = [
    {
      icon: <FaCalendarAlt size={40} className="text-primary" />,
      number: "2019",
      label: "Founded",
      description: "Established during the crypto market evolution",
    },
    {
      icon: <FaUsers size={40} className="text-success" />,
      number: "50+",
      label: "Collective Trading Years",
      description: "Combined experience across traditional and crypto markets",
    },
    {
      icon: <FaChartLine size={40} className="text-info" />,
      number: "$2.1B+",
      label: "Assets Managed",
      description: "Trusted by institutions worldwide",
    },
    {
      icon: <FaGlobe size={40} className="text-warning" />,
      number: "60+",
      label: "Countries Served",
      description: "Global regulatory coverage and compliance",
    },
  ];

  return (
    <section className="about-us-section py-5">
      <Container>
        {/* Header */}
        <Row className="justify-content-center mb-5">
          <Col md={10} lg={8}>
            <motion.div
              className="text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <h2 className="fw-bold mb-4">History</h2>
              <p className="lead text-muted mb-4">
                Founded in 2019, we are a pioneering cryptocurrency trading
                platform that bridges the gap between traditional finance and
                digital assets. With over 50 years of collective trading
                experience across our leadership team, we deliver
                institutional-grade trading solutions to both retail and
                institutional clients.
              </p>
            </motion.div>
          </Col>
        </Row>

        {/* Company Stats */}
        <Row className="g-4 mb-5">
          {companyStats.map((stat, index) => (
            <Col key={stat.label} md={6} lg={3}>
              <StatCard {...stat} index={index} />
            </Col>
          ))}
        </Row>

        {/* Mission & Vision */}
        <Row className="mb-5">
          <Col lg={6}>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <Card className="h-100 mission-card">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <FaTrophy className="text-warning me-3" size={32} />
                    <h4 className="mb-0">Our Mission</h4>
                  </div>
                  <p className="text-muted">
                    To democratize access to institutional-grade cryptocurrency
                    trading through innovative technology, proven strategies,
                    and exceptional client service. We empower investors to
                    capitalize on digital asset opportunities while maintaining
                    the highest standards of security and compliance.
                  </p>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
          <Col lg={6}>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <Card className="h-100 vision-card">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <FaRocket className="text-primary me-3" size={32} />
                    <h4 className="mb-0">Our Vision</h4>
                  </div>
                  <p className="text-muted">
                    To become the global leader in cryptocurrency trading
                    platforms by 2030, setting industry standards for
                    performance, innovation, and client satisfaction. We
                    envision a future where sophisticated trading strategies are
                    accessible to all serious investors.
                  </p>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>

        {/* Company Timeline */}
        {/* <Row className="justify-content-center">
          <Col lg={10}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <h3 className="text-center mb-4">Our Journey</h3>
              <div className="timeline">
                {milestones.map((milestone, index) => (
                  <motion.div
                    key={milestone.year}
                    className="timeline-item"
                    initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                  >
                    <div className="timeline-content">
                      <div className="timeline-year">{milestone.year}</div>
                      <h5>{milestone.title}</h5>
                      <p className="text-muted">{milestone.description}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </Col>
        </Row> */}
      </Container>
    </section>
  );
};

export default AboutUs;
